// const suppliers = (state = ['fabrication-offshore-gt-frfpcb'], action) => state;
const suppliers = (state = ['pcb-panel-share-pcbs']) => state;

export default suppliers;
